import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import {PullRequestErrorState} from '../components/PullRequestErrorState'
import type {FilesRoutePayload} from '../page-data/payloads/files'
import {DiffComparisonViewer} from '../components/DiffComparisonViewer'
import {Suspense} from 'react'

// entrypoint for JSON route - not DataRouter
export function FilesEntrypoint() {
  return (
    <ErrorBoundary critical fallback={<PullRequestErrorState text="Changes cannot be loaded" />}>
      <Files />
    </ErrorBoundary>
  )
}

export function Files() {
  const routeData = useRoutePayload<FilesRoutePayload>()

  return (
    <Suspense>
      <DiffComparisonViewer.Viewer
        basePath={routeData.pullRequest.pathName}
        initialData={routeData}
        useAdvancedToolbar
        useChangeGroups
        useInlineComments
        useEditOptions
        useFileTree
      />
    </Suspense>
  )
}

try{ FilesEntrypoint.displayName ||= 'FilesEntrypoint' } catch {}
try{ Files.displayName ||= 'Files' } catch {}